import React from 'react';
import {Text} from '@famly/mf_data-display_text';

export type ModalDescriptionProps = {
    /**
     * Description to be displayed
     */
    description: string;
};

export const ModalDescription = ({description}: ModalDescriptionProps) => {
    return (
        <Text variant="body" color="n300">
            {description}
        </Text>
    );
};
